import { render } from "./PortfolioOverview.vue?vue&type=template&id=16d30386&scoped=true"
import script from "./PortfolioOverview.vue?vue&type=script&lang=js"
export * from "./PortfolioOverview.vue?vue&type=script&lang=js"

import "./PortfolioOverview.vue?vue&type=style&index=0&id=16d30386&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d30386"],['__file',"resources/js/components/PortfolioOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16d30386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16d30386', __exports__)) {
    api.reload('16d30386', __exports__)
  }
  
  module.hot.accept("./PortfolioOverview.vue?vue&type=template&id=16d30386&scoped=true", () => {
    api.rerender('16d30386', render)
  })

}


export default __exports__